import { Paintbrush, Sparkles } from "lucide-react";
import react, { useState } from "react";

const BlogContent = ({
  tweet,
  setTweet,
  totalposts,
  setTotalPosts,
  isHashtag,
  setIsHashtag,
  createNewTweet,
  formatContent,
  platform,
  setPlatform,
}) => {
  const wordCount = tweet.trim() ? tweet.trim().split(/\s+/).length : 0;

  const platforms = ["Twitter", "LinkedIn", "Meta Threads"];

  return (
    <div className="bg-white border rounded-2xl p-6 shadow-sm">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-sm font-semibold text-gray-700">Blog Content</h2>

        <button
          onClick={() => setTweet(formatContent(tweet))}
          className="text-xs bg-gray-100 hover:bg-gray-200 px-3 py-1.5 rounded-lg flex items-center gap-1 transition"
        >
          <Paintbrush size={14} /> Beautify
        </button>
      </div>

      {/* TEXTAREA */}
      <textarea
        value={tweet}
        onChange={(e) => setTweet(e.target.value)}
        rows={18}
        className="w-full border rounded-xl px-4 py-3 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        placeholder="Paste your blog content here..."
      />

      {/* WORD COUNT */}
      <div className="text-xs text-gray-500 mt-2 flex justify-between">
        <span>{wordCount} words</span>
        <span className="text-gray-400">Tip: 120–200 words works best</span>
      </div>

      {/* OPTIONS PANEL */}
      <div className="bg-gray-50 border rounded-xl p-4 mt-6 space-y-4">
        {/* POSTS COUNT */}
        <div>
          <p className="text-xs font-medium text-gray-600 mb-2">
            Number of Posts
          </p>
          <div className="flex gap-2">
            {[2, 3, 4].map((num) => (
              <button
                key={num}
                onClick={() => setTotalPosts(num)}
                className={`px-4 py-1.5 rounded-lg text-sm transition ${
                  totalposts === num
                    ? "bg-indigo-600 text-white"
                    : "bg-white border hover:bg-gray-100"
                }`}
              >
                {num}
              </button>
            ))}
          </div>
        </div>

        {/* HASHTAGS */}
        <div>
          <p className="text-xs font-medium text-gray-600 mb-2">Hashtags</p>
          <div className="flex gap-2">
            {[
              { label: "Yes", value: 1 },
              { label: "No", value: 0 },
            ].map((opt) => (
              <button
                key={opt.value}
                onClick={() => setIsHashtag(opt.value)}
                className={`px-4 py-1.5 rounded-lg text-sm transition ${
                  isHashtag === opt.value
                    ? "bg-indigo-600 text-white"
                    : "bg-white border hover:bg-gray-100"
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        {/* PLATFORM */}
        <div>
          <p className="text-xs font-medium text-gray-600 mb-2">Platform</p>
          <div className="flex gap-2 flex-wrap">
            {platforms.map((p) => (
              <button
                key={p}
                onClick={() => setPlatform(p)}
                className={`px-4 py-1.5 rounded-lg text-sm transition ${
                  platform === p
                    ? "bg-indigo-600 text-white shadow"
                    : "bg-white border hover:bg-gray-100"
                }`}
              >
                {p}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <button
        onClick={createNewTweet}
        className="mt-6 bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-xl w-full font-semibold flex items-center justify-center gap-2 transition"
      >
        <Sparkles size={16} />
        Generate Posts
      </button>
    </div>
  );
};

export default BlogContent;
